var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1791 0.571289H8.0791L8.39993 1.14272L10.1791 4.28557H12.8333H13.4166V3.74272C13.4166 1.99986 11.9583 0.571289 10.1791 0.571289Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8041 4.28557H9.50827L7.7291 1.14272L7.40827 0.571289H3.82077C3.7916 0.571289 3.73327 0.571289 3.7041 0.571289L4.02494 1.14272L5.8041 4.28557Z",
    fill: "#2B2B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13325 4.2858L3.38325 1.17151L3.09159 0.657227C1.66242 1.00008 0.583252 2.25723 0.583252 3.74294V4.2858H1.16659H5.13325Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 4.85742H9.82908H6.12492H5.45408H1.16659H0.583252V9.97171C0.583252 11.7146 2.04159 13.1431 3.82075 13.1431H10.1791C11.9583 13.1431 13.4166 11.7146 13.4166 9.97171V4.85742H12.8333H10.4999ZM5.54158 6.85742C5.54158 6.74314 5.62908 6.65742 5.68742 6.62885C5.74575 6.60028 5.83325 6.57171 5.92075 6.57171C6.00825 6.57171 6.09575 6.60028 6.18325 6.62885L9.15825 8.48599C9.24575 8.54314 9.30408 8.62885 9.30408 8.71456C9.30408 8.80028 9.24575 8.88599 9.15825 8.94314L6.18325 10.8003C6.00825 10.9146 5.80408 10.886 5.68742 10.8003C5.62908 10.7717 5.54158 10.686 5.54158 10.5717V6.85742Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReels);
export default __webpack_public_path__ + "static/media/reels.7115f82c4e7abce7d6081ae81b93718a.svg";
export { ForwardRef as ReactComponent };